function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'black': 'rgb(0, 0, 0)','blue-jean': 'rgb(100, 118, 146)','bay': 'rgb(34, 55, 43)','berry': 'rgb(126, 73, 102)','butter': 'rgb(231, 206, 181)','blossom': 'rgb(248, 190, 214)','blue-spruce': 'rgb(62, 93, 88)','crimson': 'rgb(164, 18, 63)','chambray': 'rgb(159, 183, 201)','espresso': 'rgb(85, 60, 54)','graphite': 'rgb(29, 37, 45)','grey': 'rgb(113, 110, 106)','ivory': 'rgb(231, 206, 181)','moss': 'rgb(34, 55, 43)','mustard': 'rgb(242, 205, 0)','navy': 'rgb(12, 35, 64)','orchid': 'rgb(199, 178, 222)','pepper': 'rgb(78, 75, 72)','red': 'rgb(200, 16, 2)','true-navy': 'rgb(4, 30, 66)','white': 'rgb(255, 255, 255)','yam': 'rgb(190, 83, 28)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
